module.exports = __webpack_public_path__ + "img/kiddy_motion.179beb13.png";